export function register_ceil(Survey) {
  Survey.FunctionFactory.Instance.register("ceil", p => Math.ceil(p[0] / p[1]) * p[1]);
}
